import { useLDClient } from 'launchdarkly-react-client-sdk';

const useLDClientWrapper = function useLDClientWrapper() {
  const client = useLDClient();

  return (
    client || {
      variation: () => false,
      identify: () => {},
    }
  );
};

export default useLDClientWrapper;
